import { lobbyStore, setBlinking, useLobby } from "../../redux/lobby";
import { convertToNumber } from "../../util/util";
import { settingsStore } from "@/redux/settings";
import { LobbyWs } from "@/services/wsOutRoutes";
import { useWsConnection } from "@/redux/wsConnection";
import { doCreateGame } from "../../redux/lobby";
import { useState } from "react";
import { reportRussiaClientHealth } from "@/services/clientHealth";

function createQuickMatch() {
  const { minOpponentRating, maxOpponentRating, noGuests } =
    settingsStore.getState();

  const {
    time,
    inc,
    variant,
    modeId,
    leaguePlay,
    gamesCreated,
    filterGuestTime,
  } = lobbyStore.getState();

  const game = {
    time,
    inc,
    minElo: minOpponentRating,
    maxElo: maxOpponentRating,
    variant,
    leaguePlay,
    modeId,
    noGuests,
    filterGuestTime,
    isChessParty: true,
  };

  LobbyWs.createQuickMatch(game);
  reportRussiaClientHealth("quick_match_created", {
    time,
    inc,
    variant,
    leaguePlay,
    modeId,
    noGuests,
    filterGuestTime,
    isChessParty: true,
  });

  let gameCreated = false;
  gamesCreated.forEach((game) => {
    if (time === game.time && inc === game.inc && variant === game.variant) {
      gameCreated = true;
    }
  });
  if (!gameCreated) {
    doCreateGame({ time, inc, variant });
  }
}

export default function ChessPartyCreateGame() {
  const { time, inc, variant, gamesCreated } = useLobby();
  const { wsConnected } = useWsConnection();
  const [searchRequested, setSearchRequested] = useState(false);

  const gameRequested = gamesCreated.some(
    (game) =>
      convertToNumber(game.time) === convertToNumber(time) &&
      convertToNumber(game.inc) === convertToNumber(inc) &&
      convertToNumber(game.variant) === convertToNumber(variant),
  );
  const isSearching = searchRequested || gameRequested;

  function handlePlay() {
    let gameAlreadyRequested = false;
    gamesCreated.forEach((game) => {
      if (
        convertToNumber(game.time) === convertToNumber(time) &&
        convertToNumber(game.inc) === convertToNumber(inc) &&
        convertToNumber(game.variant) === convertToNumber(variant)
      ) {
        gameAlreadyRequested = true;
      }
    });

    setSearchRequested(true);

    if (gameAlreadyRequested) {
      setBlinking({ time, inc, variant, blinking: true });
    } else {
      createQuickMatch();
    }
  }

  return (
    <div className="w-full">
      <button
        className="w-full text-lg font-bold text-white transition-colors h-14 rounded-xl disabled:opacity-60 flex items-center justify-center gap-2"
        style={{ backgroundColor: "#1a6bab" }}
        onMouseEnter={(e) => {
          if (!e.currentTarget.disabled)
            e.currentTarget.style.backgroundColor = "#155991";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "#1a6bab";
        }}
        disabled={!wsConnected || isSearching}
        onClick={handlePlay}
      >
        {isSearching && (
          <svg className="animate-spin h-5 w-5 text-white shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
          </svg>
        )}
        {isSearching ? "Searching..." : "Play · 5 min"}
      </button>

      {/* Fixed-height slot so the button position never shifts */}
      <div className="h-6 mt-2 text-sm text-center text-gray-400">
        {searchRequested && "Finding an opponent..."}
      </div>
    </div>
  );
}
